export const environment = {
  production: true,
  urlUsuarios: 'https://d3pkipc8wz3smh.cloudfront.net/desbloqueoCuenta',
  urlApiDesbloqueo: 'https://d3pkipc8wz3smh.cloudfront.net/desbloqueoCuenta',
  siteKey: 'k7MBkv2rbj2g3hqgctTlX9v2PyDlpNoc3K1crWhe',
  version:'V.P. 1.0.1',
  apikey:'bJ1rHK1q3B6zptcwPpxE96CJE9shzmXoaPz78hHb'
};
